module.exports = __webpack_public_path__ + "media/images/supporters_lp/fork12-269eb04557280871163001163469f56b.png";